export const ICY_JOSEPH = "icyJoseph";
